import { gql } from "@apollo/client";

export const UpdateGridView = gql`
    mutation UpdateGridView ($id: ID!, $input: GridViewUpdateAttributesInput!){
        updateGridView (id: $id, input: $input) {
            id
        }
    }
`;
